/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivityLogFilter,
  AdminUserRequestPreferencesModel,
  AdminUserResponsePreferencesModel,
  BadRequest,
  Conflict,
  Forbidden,
  MultiFactorAddModel,
  NotFound,
  PaginatedActivityLogResponse,
  ProfileMultifactorResponseModel,
  ProfileRequestModel,
  ProfileResponseModel,
  Unauthorized,
} from '../models';

export interface ProfileAddUserPreferencesRequest {
    adminUserRequestPreferencesModel: AdminUserRequestPreferencesModel;
}

export interface ProfileEditProfileRequest {
    profileRequestModel: ProfileRequestModel;
}

export interface ProfileGetAuditLogsForMyActivityRequest {
    filter?: ActivityLogFilter;
    page?: number;
    limit?: number;
}

export interface ProfileUpdateUserPreferencesRequest {
    adminUserRequestPreferencesModel: AdminUserRequestPreferencesModel;
}

export interface ProfileValidateMultiFactorAuthenticationRequest {
    multiFactorAddModel: MultiFactorAddModel;
}

/**
 * 
 */
export class ProfileApi extends runtime.BaseAPI {

    /**
     * Creates initial preferences configuration for the authenticated user. Sets UI preferences, notification settings, language, timezone, and other customizable options. Use PUT endpoint to update existing preferences
     * Create User Preferences
     */
    async profileAddUserPreferencesRaw(requestParameters: ProfileAddUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserResponsePreferencesModel>> {
        if (requestParameters.adminUserRequestPreferencesModel === null || requestParameters.adminUserRequestPreferencesModel === undefined) {
            throw new runtime.RequiredError('adminUserRequestPreferencesModel','Required parameter requestParameters.adminUserRequestPreferencesModel was null or undefined when calling profileAddUserPreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me/preferences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.adminUserRequestPreferencesModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates initial preferences configuration for the authenticated user. Sets UI preferences, notification settings, language, timezone, and other customizable options. Use PUT endpoint to update existing preferences
     * Create User Preferences
     */
    async profileAddUserPreferences(requestParameters: ProfileAddUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserResponsePreferencesModel> {
        const response = await this.profileAddUserPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes multi-factor authentication from the user\'s account. After removal, user will no longer need TOTP codes for login. This action reduces account security and should be used cautiously
     * Disable Account Multi-Factor Authentication
     */
    async profileDeleteMultiFactorAuthenticationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/multifactor`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes multi-factor authentication from the user\'s account. After removal, user will no longer need TOTP codes for login. This action reduces account security and should be used cautiously
     * Disable Account Multi-Factor Authentication
     */
    async profileDeleteMultiFactorAuthentication(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.profileDeleteMultiFactorAuthenticationRaw(initOverrides);
    }

    /**
     * Updates the authenticated user\'s profile information. Allows modification of personal details, contact information, and account settings. Changes are validated and synchronized across the system
     * Edit Account Information
     */
    async profileEditProfileRaw(requestParameters: ProfileEditProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponseModel>> {
        if (requestParameters.profileRequestModel === null || requestParameters.profileRequestModel === undefined) {
            throw new runtime.RequiredError('profileRequestModel','Required parameter requestParameters.profileRequestModel was null or undefined when calling profileEditProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.profileRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates the authenticated user\'s profile information. Allows modification of personal details, contact information, and account settings. Changes are validated and synchronized across the system
     * Edit Account Information
     */
    async profileEditProfile(requestParameters: ProfileEditProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponseModel> {
        const response = await this.profileEditProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of audit logs for the authenticated user\'s activities. Returns user actions, timestamps, IP addresses, and affected resources. Supports filtering by date range, action type, and resource
     * Get List of Audit Logs
     */
    async profileGetAuditLogsForMyActivityRaw(requestParameters: ProfileGetAuditLogsForMyActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedActivityLogResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me/activities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of audit logs for the authenticated user\'s activities. Returns user actions, timestamps, IP addresses, and affected resources. Supports filtering by date range, action type, and resource
     * Get List of Audit Logs
     */
    async profileGetAuditLogsForMyActivity(requestParameters: ProfileGetAuditLogsForMyActivityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedActivityLogResponse> {
        const response = await this.profileGetAuditLogsForMyActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the authenticated user\'s complete profile information. Returns user details including personal information, contact data, account status, roles, and associated tenants
     * Get Account Information
     */
    async profileGetProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the authenticated user\'s complete profile information. Returns user details including personal information, contact data, account status, roles, and associated tenants
     * Get Account Information
     */
    async profileGetProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponseModel> {
        const response = await this.profileGetProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the authenticated user\'s application preferences and settings. Returns UI preferences, notification settings, language, timezone, and other customizable options
     * Get Account Preferences
     */
    async profileGetUserPreferencesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserResponsePreferencesModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me/preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the authenticated user\'s application preferences and settings. Returns UI preferences, notification settings, language, timezone, and other customizable options
     * Get Account Preferences
     */
    async profileGetUserPreferences(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserResponsePreferencesModel> {
        const response = await this.profileGetUserPreferencesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Initiates multi-factor authentication (MFA) setup for the authenticated user. Returns QR code and secret key for configuring authenticator apps (Google Authenticator, Authy, etc.). User must validate with a TOTP code to complete setup
     * Start Multi-Factor Authentication Setup
     */
    async profileStartMultiFactorAuthenticationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileMultifactorResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/multifactor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Initiates multi-factor authentication (MFA) setup for the authenticated user. Returns QR code and secret key for configuring authenticator apps (Google Authenticator, Authy, etc.). User must validate with a TOTP code to complete setup
     * Start Multi-Factor Authentication Setup
     */
    async profileStartMultiFactorAuthentication(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileMultifactorResponseModel> {
        const response = await this.profileStartMultiFactorAuthenticationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates existing preferences configuration for the authenticated user. Modifies UI preferences, notification settings, language, timezone, and other customizable options. Changes are applied immediately
     * Edit User Preferences
     */
    async profileUpdateUserPreferencesRaw(requestParameters: ProfileUpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserResponsePreferencesModel>> {
        if (requestParameters.adminUserRequestPreferencesModel === null || requestParameters.adminUserRequestPreferencesModel === undefined) {
            throw new runtime.RequiredError('adminUserRequestPreferencesModel','Required parameter requestParameters.adminUserRequestPreferencesModel was null or undefined when calling profileUpdateUserPreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/me/preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.adminUserRequestPreferencesModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates existing preferences configuration for the authenticated user. Modifies UI preferences, notification settings, language, timezone, and other customizable options. Changes are applied immediately
     * Edit User Preferences
     */
    async profileUpdateUserPreferences(requestParameters: ProfileUpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserResponsePreferencesModel> {
        const response = await this.profileUpdateUserPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Completes multi-factor authentication setup by validating a TOTP code from the user\'s authenticator app. After validation, MFA is enabled and will be required for future logins
     * Validate and Enable Multi-Factor Authentication
     */
    async profileValidateMultiFactorAuthenticationRaw(requestParameters: ProfileValidateMultiFactorAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.multiFactorAddModel === null || requestParameters.multiFactorAddModel === undefined) {
            throw new runtime.RequiredError('multiFactorAddModel','Required parameter requestParameters.multiFactorAddModel was null or undefined when calling profileValidateMultiFactorAuthentication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/profile/multifactor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.multiFactorAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Completes multi-factor authentication setup by validating a TOTP code from the user\'s authenticator app. After validation, MFA is enabled and will be required for future logins
     * Validate and Enable Multi-Factor Authentication
     */
    async profileValidateMultiFactorAuthentication(requestParameters: ProfileValidateMultiFactorAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.profileValidateMultiFactorAuthenticationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
